import { Form } from 'react-bootstrap';

function format(value) {
	if (!value) return value;
	const phoneNumber = value.replace(/[^\d]/g, '');
	if (phoneNumber.length < 4) {
		return phoneNumber;
	}
	if (phoneNumber.length < 7) {
		return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
	}
	return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
		3,
		6
	)}-${phoneNumber.slice(6, 10)}`;
}

export const PhoneNumber = ({ register, registerName = 'phone' }) => {
	const handleChange = e => {
		const formattedPhoneNumber = format(e.target.value);
		e.target.value = formattedPhoneNumber;
	};

	return (
		<Form.Control
			placeholder="(xxx) xxx-xxxx"
			{...register(registerName, {
				onChange: handleChange,
				setValueAs: format,
			})}
		/>
	);
};
